<template>
  <nav id="nav" class="DesktopNav" :class="{ '-logoLeft': logoLeft }" @click="scrollToTop()">
    <div class="inner-nav">
      <div class="item nav-left-wrapper">
        <router-link class="site-brand" :to="{ name: 'root' }" active-class="home">
          <img v-if="!hideSiteFavicon" class="favicon" src="/favicon.png">
          <span v-if="!hideSiteName" class="site-name">
            {{ sitename }}
          </span>
        </router-link>
      </div>
      <router-link class="logo" :to="{ name: 'root' }">
        <img :src="logo">
      </router-link>
      <div class="item right actions">
        <button
          v-if="currentUser || !privateMode"
          class="button-unstyled nav-icon"
          :title="$t('nav.search')"
          type="button"
          @click.stop="openSearchModal"
        >
          <FAIcon
            fixed-width
            class="fa-scale-110 fa-old-padding"
            icon="search"
          />
        </button>
        <button class="button-unstyled nav-icon" @click.stop="openSettingsModal">
          <FAIcon fixed-width class="fa-scale-110 fa-old-padding" icon="cog" :title="$t('nav.preferences')" />
        </button>
        <button class="button-unstyled nav-icon" @click.stop="openThemeTab">
          <FAIcon fixed-width class="fa-scale-110 fa-old-padding" icon="paint-brush" :title="theme" />
        </button>
        <button v-if="currentUser && currentUser.role === 'admin' || currentUser.role === 'moderator'" class="button-unstyled nav-icon" @click.stop="openModModal">
          <FAIcon fixed-width class="fa-scale-110 fa-old-padding" icon="user-tie" :title="$t('nav.moderation')" />
        </button>
        <a v-if="currentUser && currentUser.role === 'admin'" href="/pleroma/admin/#/login-pleroma" class="nav-icon" target="_blank" @click.stop>
          <FAIcon fixed-width class="fa-scale-110 fa-old-padding" icon="tachometer-alt" :title="$t('nav.administration')" />
        </a>
      </div>
    </div>
    <teleport to="#modal">
      <confirm-modal v-if="showingConfirmLogout" :title="$t('login.logout_confirm_title')"
        :confirm-text="$t('login.logout_confirm_accept_button')" :cancel-text="$t('login.logout_confirm_cancel_button')"
        @accepted="doLogout" @cancelled="hideConfirmLogout">
        {{ $t('login.logout_confirm') }}
      </confirm-modal>
    </teleport>
  </nav>
</template>
<script src="./desktop_nav.js"></script>

<style src="./desktop_nav.scss" lang="scss"></style>
